import React, { useEffect, useState } from 'react';
import Modal from '../Common/Modal';
import SegToggle from '../Common/SegToggle';
import Dropdown from '../Common/Dropdown';
import Collapse from '../Common/Collapse';
import { CoverPattern, shade } from './CourseCover';
import { CourseIcon as LibIcon } from './iconLibrary';
import { getTrialAccess, setTrialAccess, getCourses } from '../../services/adminService';
import toast from 'react-hot-toast';

/* Доступ к пробным занятиям.

   Куратор отмечает галочками занятия, открытые ученикам с пометкой «пробник».
   Разложено так же, как в карточке ученика: тумблер «Вебинары / Домашние
   задания / Варианты», внутри модули, внутри занятия.

   Отметка общая на занятие, а не на каждого пробника. Исключение считается на
   стороне ученика: вебинар, который он уже посмотрел, ему не открывается. */

const TABS = [
  { key: 'webinars', label: 'Вебинары' },
  { key: 'homework', label: 'Домашние задания' },
  { key: 'variants', label: 'Варианты' },
];

const MonthRu = ['ЯНВ', 'ФЕВ', 'МАР', 'АПР', 'МАЯ', 'ИЮН', 'ИЮЛ', 'АВГ', 'СЕН', 'ОКТ', 'НОЯ', 'ДЕК'];
const DaysRu = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];

// Смотрит вправо и поворачивается на 90° — как в карточке ученика
const IcChevron = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);
const IcCheck = () => (
  <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);
const IcLock = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
    <rect x="4" y="10.5" width="16" height="10.5" rx="2.4" /><path d="M8 10.5V7a4 4 0 0 1 8 0v3.5" />
  </svg>
);
const IcCalendar = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" /><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
  </svg>
);
const IcChevronDown = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);
const IcCourses = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2 2 7l10 5 10-5-10-5z" /><path d="M2 17l10 5 10-5M2 12l10 5 10-5" />
  </svg>
);
const IcWeb = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="15" height="16" rx="3" /><path d="m17 10 5-3v10l-5-3z" />
  </svg>
);
const IcHw = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);
const IcVar = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" /><rect x="9" y="3" width="6" height="4" rx="2" />
  </svg>
);

const TAB_ICON = { webinars: <IcWeb />, homework: <IcHw />, variants: <IcVar /> };

const plural = (n, f) => {
  const a = Math.abs(n) % 100, b = a % 10;
  if (a > 10 && a < 20) return f[2];
  if (b > 1 && b < 5) return f[1];
  if (b === 1) return f[0];
  return f[2];
};
const fmtDur = (m) => (m >= 60 ? `${Math.floor(m / 60)} ч ${m % 60 ? `${m % 60} мин` : ''}`.trim() : `${m} мин`);

const Box = ({ on, half }) => (
  <span className={`ta-box${on ? ' on' : ''}${half ? ' half' : ''}`}>
    {on ? <IcCheck /> : half ? <span className="ta-dash" /> : null}
  </span>
);

/* Модуль — один в один карточка из «Успеваемости» ученика, только вместо
   «Просмотрено 0/1» галочка «открыть весь модуль». */
function ModuleCard({ sec, icon, sub, picked, onToggleAll, children }) {
  const [open, setOpen] = useState(false);
  const ids = sec.lessons.map(l => l.id);
  const on = ids.filter(id => picked.has(id)).length;
  return (
    <div className={`mod${open ? ' open' : ''}`}>
      <div className="mod-head" onClick={() => setOpen(o => !o)}>
        <div className="mod-ic">{icon}</div>
        <div className="mod-info">
          <div className="mod-title">{sec.name}</div>
          <div className="mod-sub">{sub}</div>
        </div>
        <div className="ta-mod-pick" onClick={(e) => { e.stopPropagation(); onToggleAll(sec); }}
          title={on === ids.length && ids.length ? 'Снять весь модуль' : 'Открыть весь модуль'}>
          <span className="ta-mod-cnt">{on} из {ids.length}</span>
          <Box on={ids.length > 0 && on === ids.length} half={on > 0 && on < ids.length} />
        </div>
        <span className="mod-chev"><IcChevron /></span>
      </div>
      <Collapse open={open} keepMounted>
        <div className="mod-body">{children}</div>
      </Collapse>
    </div>
  );
}

export default function TrialAccessModal({ open, onClose }) {
  const [courses, setCourses] = useState([]);
  const [courseId, setCourseId] = useState(null);
  const [coursePick, setCoursePick] = useState(false);
  const [tab, setTab] = useState('webinars');
  const [data, setData] = useState({ webinars: [], homework: [], variants: [] });
  const [trials, setTrials] = useState(0);
  const [picked, setPicked] = useState(() => new Set());
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    getCourses()
      .then(r => {
        const cs = (r.data || []).filter(c => c.isActive !== false);
        setCourses(cs);
        // по умолчанию — курс ЕГЭ, его открывают чаще всего
        setCourseId(prev => (cs.some(c => c.id === prev) ? prev
          : (cs.find(c => c.examType === 'ЕГЭ')?.id ?? cs[0]?.id ?? null)));
      })
      .catch(() => toast.error('Не удалось загрузить курсы'));
  }, [open]);

  useEffect(() => {
    if (!open || !courseId) return;
    setLoading(true);
    getTrialAccess(courseId)
      .then(r => {
        const d = r.data || { webinars: [], homework: [], variants: [] };
        setData(d);
        setTrials(r.trials || 0);
        const on = new Set();
        ['webinars', 'homework', 'variants'].forEach(k =>
          (d[k] || []).forEach(sec => sec.lessons.forEach(l => { if (l.trialAccess) on.add(l.id); })));
        setPicked(on);
      })
      .catch(() => toast.error('Не удалось загрузить занятия'))
      .finally(() => setLoading(false));
  }, [open, courseId]);

  const course = courses.find(c => c.id === courseId);
  const groups = data[tab] || [];
  const totalIds = new Set(['webinars', 'homework', 'variants']
    .flatMap(k => (data[k] || []).flatMap(sec => sec.lessons.map(l => l.id))));

  const toggle = (id) => setPicked(p => {
    const n = new Set(p);
    if (n.has(id)) n.delete(id); else n.add(id);
    return n;
  });

  const toggleSection = (sec) => setPicked(p => {
    const n = new Set(p);
    const ids = sec.lessons.map(l => l.id);
    const allOn = ids.every(id => n.has(id));
    ids.forEach(id => (allOn ? n.delete(id) : n.add(id)));
    return n;
  });

  const save = async () => {
    setSaving(true);
    try {
      await setTrialAccess(courseId, [...picked]);
      toast.success(picked.size ? `Открыто занятий: ${picked.size}` : 'Пробникам ничего не открыто');
      onClose();
    } catch (e) {
      toast.error(e?.response?.data?.message || 'Не удалось сохранить');
    } finally {
      setSaving(false);
    }
  };

  const subOf = (sec) => {
    const n = sec.lessons.length;
    if (tab === 'webinars') {
      const min = sec.lessons.reduce((s, l) => s + (l.duration || 0), 0);
      return `${n} ${plural(n, ['вебинар', 'вебинара', 'вебинаров'])}${min > 0 ? ` · ${fmtDur(min)}` : ''}`;
    }
    if (tab === 'variants') return `${n} ${plural(n, ['вариант', 'варианта', 'вариантов'])}`;
    return `${n} ${plural(n, ['задание', 'задания', 'заданий'])}`;
  };

  return (
    <>
      <Modal isOpen={open} onClose={onClose} bare>
        <div className="adm-modal ta-modal">
          <div className="adm-modal-head">
            <span className="adm-head-ic"><IcLock /></span>
            <div className="adm-head-tt">
              <div className="adm-modal-title">Доступ к пробным занятиям</div>
              <div className="adm-modal-desc">
                Отмеченное открыто ученикам с пометкой «пробник».
                {trials > 0 && ` На курсе ${trials} ${plural(trials, ['пробник', 'пробника', 'пробников'])}.`}
              </div>
            </div>
            <button type="button" className="adm-x" onClick={onClose} aria-label="Закрыть">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
            </button>
          </div>

          {/* Выбор курса и разделы — одной строкой, как панель в «Учениках» */}
          <div className="ta-bar">
            <button type="button" className="stu-pick" onClick={() => setCoursePick(true)}
              title={course?.name || ''}>
              {/* Иконка выбранного курса — она же на его обложке */}
              {course?.icon ? <LibIcon icon={course.icon} size={16} /> : <IcCourses />}
              <span className="stu-pick-t">{course?.name || 'Выбрать курс'}</span>
              {/* Стрелка вниз: показывает, что курс можно сменить */}
              <span className="ta-pick-chev"><IcChevronDown /></span>
            </button>
            <div className="ta-tabs">
              <SegToggle value={tab} onChange={setTab} options={TABS} />
            </div>
            <div className="ta-tabs-sel">
              <Dropdown value={tab} onChange={setTab} options={TABS.map(t => ({ value: t.key, label: t.label }))} />
            </div>
          </div>

          {/* Высота фиксирована: при переключении разделов окно не должно скакать */}
          <div className="ta-body">
            {loading ? (
              <div className="ta-empty">Загружаем занятия…</div>
            ) : groups.length === 0 ? (
              <div className="ta-empty">В этом разделе пока нет занятий.</div>
            ) : groups.map(sec => (
              <ModuleCard key={`${tab}:${sec.id}`} sec={sec} icon={TAB_ICON[tab]}
                sub={subOf(sec)} picked={picked} onToggleAll={toggleSection}>
                <div className="tline">
                  {sec.lessons.map(l => {
                    const d = l.date ? new Date(l.date) : null;
                    const isOn = picked.has(l.id);
                    return (
                      <div key={l.id} className={`titem${isOn ? ' done' : ''}`}>
                        <div className={`ccard ta-pick-card${isOn ? '' : ' locked'}`}
                          onClick={() => toggle(l.id)}>
                          <div className="dbadge past">
                            {d ? (<><span className="d">{d.getDate()}</span><span className="m">{MonthRu[d.getMonth()]}</span></>) : <IcCalendar />}
                          </div>
                          <div className="linfo">
                            <div className="lname">{l.title}</div>
                            <div className="lmeta">
                              {d && <span><b>{DaysRu[d.getDay()]}</b>{l.time ? `, ${String(l.time).slice(0, 5)}` : ''}</span>}
                              {l.duration > 0 && <span>· {fmtDur(l.duration)}</span>}
                              {l.hwCount > 0 && <span>· {l.hwCount} {plural(l.hwCount, ['номер', 'номера', 'номеров'])}</span>}
                              {!l.isPublished && <span>· черновик</span>}
                            </div>
                          </div>
                          <div className="lright">
                            {isOn
                              ? <span className="pg-chip green">Открыт</span>
                              : <span className="lock-chip" title="Закрыт для пробников"><IcLock /></span>}
                            <Box on={isOn} />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </ModuleCard>
            ))}
          </div>

          <div className="adm-modal-foot">
            <span className="ta-count">Открыто {picked.size} из {totalIds.size}</span>
            <div className="ta-foot-btns">
              <button type="button" className="pg-btn ghost" onClick={() => setPicked(new Set())} disabled={!picked.size}>Снять всё</button>
              <button type="button" className="pg-btn" onClick={save} disabled={saving || loading}>
                {saving ? 'Сохраняем…' : 'Сохранить'}
              </button>
            </div>
          </div>
        </div>
      </Modal>

      {/* Выбор курса — те же карточки, что в «Учениках» */}
      <Modal isOpen={coursePick} onClose={() => setCoursePick(false)} bare>
        <div className="adm-modal stu-cm" onClick={e => e.stopPropagation()}>
          <div className="stu-cm-head">
            <div style={{ flex: 1, minWidth: 0 }}>
              <div className="stu-cm-t">Выбрать курс</div>
              <div className="stu-cm-s">занятия какого курса открывать пробникам</div>
            </div>
            <button type="button" className="adm-x" onClick={() => setCoursePick(false)} aria-label="Закрыть">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
            </button>
          </div>
          <div className="stu-cm-grid">
            {courses.map(c => {
              const col = c.color || '#7c4dff';
              return (
                <button key={c.id} type="button"
                  className={`stu-cc${courseId === c.id ? ' on' : ''}`}
                  onClick={() => { setCourseId(c.id); setCoursePick(false); }}>
                  <span className="stu-cc-cover" style={{
                    '--st-t-light': `${col}80`, '--st-t-dark': `${col}38`,
                    '--st-chip-fg': shade(col, -42), '--st-chip-fg-dark': shade(col, 55), '--st-c': col,
                  }}>
                    <span className="st-crs-pat"><CoverPattern id={`ta${c.id}`} /></span>
                    <span className="stu-cc-top">
                      {c.examType && <span className="st-crs-lvl"><i />{c.examType}</span>}
                      <span className="st-crs-ic"><LibIcon icon={c.icon} size={15} /></span>
                    </span>
                    <span className="stu-cc-name">{c.name}</span>
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      </Modal>
    </>
  );
}
